import React, { useState, useEffect } from 'react';
import { isMobile } from '@/biz/tool';
import WebModal from '../Modal';
import Delivery from './Delivery';
import Cta from './Cta';
import Policy from './Policy';
import Payment from './Payment';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import {
  CloseBgIcon,
  SuccessIcon,
  FlexibleSageIcon
} from '@/components/common/icon';
import BottomDrawer from '../BottomDrawer';
import { items } from './config';
import { AdsCampaignMarketingStrategy } from '@/interface/campaign';
import CampaignMarketingStrategyTag from '@/components/web/components/CampaignMarketingStrategyTag';
import { useTranslation } from 'react-i18next';

interface Props {}

const ModalEducation: React.FC<Props> = ({}) => {
  const { t } = useTranslation();
  const { showEducationModal, educationInfo, setEducationModal } =
    useWebModalStore();

  const [step, setStep] = useState(0);
  const [maxStep, setMaxStep] = useState(
    !!localStorage.getItem('educationModalEnd') ? 3 : 0
  );
  const { order, campaign } = educationInfo || {};
  const { platform, interestedPriceFields, marketingStrategy } = order || {};

  const contentType = interestedPriceFields?.[0]?.contentType;

  useEffect(() => {
    return function () {
      setStep(0);
    };
  }, []);

  const isEnd = localStorage.getItem('educationModalEnd') === '1';

  return (
    <>
      {isMobile() ? (
        <BottomDrawer
          className="!max-h-[calc(100%_-_80px)]"
          isShowHeader={false}
          isShowFooter={false}
          visible={showEducationModal}
        >
          <div className={`h-[calc(100vh-120px)] bg-white`}>
            {step === 0 && (
              <Delivery
                step={step}
                setStep={setStep}
                platform={platform}
                contentType={contentType}
                maxStep={maxStep}
                setMaxStep={setMaxStep}
                isAffiliate={
                  marketingStrategy ===
                  AdsCampaignMarketingStrategy.AFFILIATES_MARKETING
                }
              />
            )}
            {step === 1 && (
              <Cta
                step={step}
                setStep={setStep}
                platform={platform}
                maxStep={maxStep}
                setMaxStep={setMaxStep}
              />
            )}
            {step === 2 && (
              <Policy
                step={step}
                setStep={setStep}
                platform={platform}
                maxStep={maxStep}
                setMaxStep={setMaxStep}
              />
            )}
            {step === 3 && (
              <Payment
                step={step}
                setStep={setStep}
                maxStep={maxStep}
                setMaxStep={setMaxStep}
                isAffiliate={
                  marketingStrategy ===
                  AdsCampaignMarketingStrategy.AFFILIATES_MARKETING
                }
              />
            )}
          </div>
        </BottomDrawer>
      ) : (
        <WebModal
          title={t('modal.education.title', { defaultValue: 'Deal withdrawn' })}
          visible={showEducationModal}
          isShowFooter={false}
          isShowHeader={false}
          width={1200}
          className=" bg-[#F6F6F4] p-0 rounded-[24px] overflow-hidden"
          modalStyle={{ zIndex: '1400' }}
        >
          <div className="bg-[#F6F6F4] flex items-stretch justify-between w-full h-full overflow-y-scroll relative">
            <div className="w-[360px] flex-shrink-0 pr-4 p-8 relative">
              <div className="self-stretch inline-flex flex-col justify-start items-start gap-4">
                <div className="self-stretch justify-start text-black text-[24px] font-semibold font-['Plus_Jakarta_Sans'] leading-9">
                  {t('modal.education.onboarding_title', {
                    defaultValue: 'Onboarding Training'
                  })}
                </div>
                {campaign?.isTrendCampaign ? (
                  <div
                    data-state="Secondary"
                    className="h-5 px-2.5 py-0.5 bg-neutral-100 rounded-lg outline outline-1 outline-offset-[-1px] outline-gray-300 inline-flex flex-col justify-center items-center gap-2.5"
                  >
                    <div className="inline-flex justify-center items-center gap-2.5">
                      <div className="justify-start text-neutral-500 text-xs font-medium font-['Inter']">
                        Trend campaign
                      </div>
                    </div>
                  </div>
                ) : (
                  <CampaignMarketingStrategyTag
                    campaignData={{ marketingStrategy: marketingStrategy }}
                    className="bg-[#DDD6FF] !text-[#0D0D0D]"
                  />
                )}
                <div className="self-stretch justify-start text-[#60646c] text-sm font-normal font-['Inter'] leading-snug">
                  {marketingStrategy ===
                  AdsCampaignMarketingStrategy.AFFILIATES_MARKETING
                    ? t('modal.education.affiliate_desc', {
                        defaultValue:
                          'Learn about how Affiliate collaboration works to ensure a successful collaboration and get paid for your work'
                      })
                    : t('modal.education.creator_desc', {
                        defaultValue:
                          'Learn Aha Creator essentials to ensure a successful collaboration and get paid for your work'
                      })}
                </div>
              </div>
              <div className="mt-8 flex flex-col gap-4">
                {items?.map((item, index) => (
                  <div
                    key={item}
                    className={`self-stretch px-4 py-3.5 rounded-[999px] inline-flex justify-start items-center gap-2
                    ${step === index ? 'bg-white outline outline-[1.50px] outline-offset-[-1.50px] outline-[#5a31f0] shadow-[0px_1px_3px_0px_rgba(18,18,23,0.10)]' : 'bg-[#F6F6F4]'} ${maxStep >= index ? 'cursor-pointer' : ''}`}
                    onClick={() => {
                      if (maxStep >= index) {
                        setStep(index);
                      }
                    }}
                  >
                    <div
                      className={`w-[24px] h-[24px] rounded-[24px] flex items-center justify-center ${step === index ? 'bg-[#5A31F0] text-white' : 'bg-[#D8DBFF] text-[#5A31F0]'}`}
                    >
                      {step > index ? (
                        <SuccessIcon className="w-[24px] h-[24px]" />
                      ) : (
                        <span>{index + 1}</span>
                      )}
                    </div>
                    <div className="justify-start text-[#1c2024] text-sm font-semibold font-['Plus_Jakarta_Sans'] leading-normal">
                      {item}
                    </div>
                  </div>
                ))}
              </div>
            </div>
            {isEnd && (
              <div
                className="absolute top-[20px] right-[20px] cursor-pointer"
                onClick={() => {
                  setEducationModal(false, {});
                }}
              >
                <CloseBgIcon />
              </div>
            )}
            <div className="bg-white w-full">
              {step === 0 && (
                <Delivery
                  step={step}
                  setStep={setStep}
                  platform={platform}
                  contentType={contentType}
                  maxStep={maxStep}
                  setMaxStep={setMaxStep}
                  isAffiliate={
                    marketingStrategy ===
                    AdsCampaignMarketingStrategy.AFFILIATES_MARKETING
                  }
                />
              )}
              {step === 1 && (
                <Cta
                  step={step}
                  setStep={setStep}
                  platform={platform}
                  maxStep={maxStep}
                  setMaxStep={setMaxStep}
                />
              )}
              {step === 2 && (
                <Policy
                  step={step}
                  setStep={setStep}
                  platform={platform}
                  maxStep={maxStep}
                  setMaxStep={setMaxStep}
                />
              )}
              {step === 3 && (
                <Payment
                  step={step}
                  setStep={setStep}
                  maxStep={maxStep}
                  setMaxStep={setMaxStep}
                  isAffiliate={
                    marketingStrategy ===
                    AdsCampaignMarketingStrategy.AFFILIATES_MARKETING
                  }
                />
              )}
            </div>
          </div>
        </WebModal>
      )}
    </>
  );
};

export default ModalEducation;
